import React from "react";
import { AiIcon, DataTable, Table, Tooltip } from "@sscs/ui";
import { REPORT_PAGES_ROUTES } from "../../../constants";
import { expandedRowsUpdated, focusedRowUpdated, selectExpandedRow, selectFocusedRow, tagFiltered, } from "../../../store/vulnerabilitySlice";
import { ExpandedRowDetails } from "../../../ui";
import { CvssDetails, IssuesList, VulnerabilityScore, VulnerabilityTags, } from "../../common";
import { useReportDispatch, useReportSelector } from "../../hooks";
import CommonBugInfo from "./CommonBugInfo";
import styles from "./vulnerability.module.scss";
import VulnerabilityReferences from "./VulnerabilityReferences";
const Vulnerability = ({ rowIndex, vulnerability, }) => {
    var _a;
    const dispatch = useReportDispatch();
    const focusedRow = useReportSelector(selectFocusedRow);
    const expanded = useReportSelector((state) => selectExpandedRow(state, vulnerability.cve_number));
    return (React.createElement(DataTable.ExpandedRow, { id: `bom-vulnerabilities-expand-row-${rowIndex}`, expanded: expanded, focused: focusedRow === vulnerability.cve_number, onChange: (isExpanded) => dispatch(expandedRowsUpdated({
            id: vulnerability.cve_number,
            expand: isExpanded,
        })), onClick: () => dispatch(focusedRowUpdated(vulnerability.cve_number)) },
        React.createElement(DataTable.ExpandedRow.Summary, null,
            React.createElement(Table.Cell, null,
                React.createElement(VulnerabilityScore, { cvss: vulnerability.cvss, exploit: vulnerability.exploit })),
            React.createElement(Table.Cell, null,
                vulnerability.cve_number,
                React.createElement("div", { className: styles["marketing-name"] }, vulnerability.name)),
            React.createElement(Table.Cell, null,
                React.createElement("div", { className: styles.summary },
                    React.createElement(Tooltip, { trigger: "graphic", title: "AI generated summary" },
                        React.createElement(AiIcon, { className: styles["ai-icon"] })),
                    React.createElement("span", null, ((_a = vulnerability.bug_details) === null || _a === void 0 ? void 0 : _a.summary)
                        ? vulnerability.bug_details.summary
                        : "AI summary not yet generated."))),
            React.createElement(Table.Cell, null,
                React.createElement(VulnerabilityTags, { tags: vulnerability.exploit, onClick: (tag) => dispatch(tagFiltered([tag])) }))),
        React.createElement(DataTable.ExpandedRow.Details, null,
            React.createElement(ExpandedRowDetails, null,
                React.createElement(ExpandedRowDetails.Aside, null,
                    React.createElement(CvssDetails, { cvss: vulnerability.cvss })),
                vulnerability.bug_details && (React.createElement(ExpandedRowDetails.Main, null,
                    React.createElement(CommonBugInfo, { bugDetails: vulnerability.bug_details, sources: vulnerability.sources }),
                    React.createElement(IssuesList, { violations: vulnerability.violations, to: REPORT_PAGES_ROUTES.ISSUES_ROUTE }))),
                React.createElement(ExpandedRowDetails.FullWidth, null,
                    React.createElement(VulnerabilityReferences, { id: `bom-vulnerabilities-${rowIndex}`, cve: vulnerability.cve_number, source_count: vulnerability.reference_count }))))));
};
export default Vulnerability;
//# sourceMappingURL=Vulnerability.js.map